import { Controller } from "@hotwired/stimulus";
import { gsap } from "gsap";
import { whenStageActive } from "./utils/when_stage_active";

// Fills a horizontal bar from 0% to a target
// percentage when the closest audit stage becomes
// active. Pairs with audit_count_up_controller to
// drive the score-row reveal: bar grows + number
// counts up in lockstep.
//
// Honors prefers-reduced-motion: snaps to final
// width immediately.
//
// Why deferred play: the audit show page renders all
// stages up front (hidden by CSS). Without
// `whenStageActive`, the fill would tween while the
// stage is `display: none`, ending before the user
// sees it.
//
// Values:
// - to (Number, required): percent (0-100).
// - duration (Number, default 0.8): seconds.
// - delay (Number, default 0): seconds before start.
// - ease (String, default "power3.out"): GSAP ease.
export default class extends Controller {
  static values = {
    to: { type: Number, default: 0 },
    duration: { type: Number, default: 0.8 },
    delay: { type: Number, default: 0 },
    ease: { type: String, default: "power3.out" },
  };

  connect() {
    this.element.style.width = "0%";

    this.cancelWait = whenStageActive(
      this.element,
      () => this.play()
    );
  }

  disconnect() {
    this.cancelWait?.();
    this.tween?.kill();
  }

  play() {
    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reduced) {
      this.element.style.width = `${this.toValue}%`;
      return;
    }

    this.element.style.width = "0%";
    this.tween = gsap.to(this.element, {
      width: `${this.toValue}%`,
      duration: this.durationValue,
      delay: this.delayValue,
      ease: this.easeValue,
    });
  }
}
